import cortanaComposeStore from '../store/cortanaComposeStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setCachedDoradoSearchResults', function setCachedDoradoSearchResults(
    doradoSearchResults: any
) {
    cortanaComposeStore.cachedDoradoSearchResults = doradoSearchResults;
});
